import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-language-services-publishing-and-media',
  templateUrl: './language-services-publishing-and-media.component.html',
  styleUrls: ['./language-services-publishing-and-media.component.scss']
})
export class LanguageServicesPublishingAndMediaComponent implements OnInit {

  email: any;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("트링카 엔터프라이즈 | 언어 서비스, 출판 및 미디어");
    this.metaTagService.updateTag({ name: 'description', content: "팀이 일관성을 유지하는 글을 쓰고 이를 더 빠르게 출판하여 고객 경험을 향상할 수 있습니다. 명확성을 흐리지 않으면서도 글쓰기에 드는 시간과 비용을 줄여보세요." });
    this.metaTagService.updateTag({ property: 'og:title', content: "트링카 엔터프라이즈 | 언어 서비스, 출판 및 미디어" });
    this.metaTagService.updateTag({ property: 'og:description', content: "팀이 일관성을 유지하는 글을 쓰고 이를 더 빠르게 출판하여 고객 경험을 향상할 수 있습니다. 명확성을 흐리지 않으면서도 글쓰기에 드는 시간과 비용을 줄여보세요." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/language-services-publishing-and-media.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '트링카 엔터프라이즈 | 언어 서비스, 출판 및 미디어' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "팀이 일관성을 유지하는 글을 쓰고 이를 더 빠르게 출판하여 고객 경험을 향상할 수 있습니다. 명확성을 흐리지 않으면서도 글쓰기에 드는 시간과 비용을 줄여보세요." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/language-services-publishing-and-media.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
  }
  
}
